
export const convertJsonToString = (s: string) => {
    return !!s && typeof s === 'string' ? JSON.parse(s) : '';
}
export const convertJsonToString = (s: string) => {
    return !!s && typeof s === 'string' ? JSON.parse(s) : '';
}